import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      order: 'getOrder'
    })
  }
}